import invariant from 'invariant';
import searchAPI from 'search/api/searchAPI';
import { ActionTypes } from 'search/constants';
import { Dispatcher } from 'search/Dispatcher';

export const SearchActionCreators = {
  changePage(pageNumber) {
    Dispatcher.handleViewAction({
      type: ActionTypes.CHANGE_PAGE,
      page: pageNumber
    });
    searchAPI.searchVenues();
  },

  changeEventTypeFilter(eventTypeId) {
    Dispatcher.handleViewAction({
      type: ActionTypes.CHANGE_FILTER_EVENT_TYPE,
      eventTypeId: eventTypeId
    });
    searchAPI.searchVenues();
  },

  changeVenueTypeFilter(venueTypeIds) {
    Dispatcher.handleViewAction({
      type: ActionTypes.CHANGE_FILTER_VENUE_TYPES,
      venueTypeIds: venueTypeIds
    });
    searchAPI.searchVenues();
  },

  changePeopleFilter(people) {
    Dispatcher.handleViewAction({
      type: ActionTypes.CHANGE_FILTER_PEOPLE,
      people: people
    });
    searchAPI.searchVenues();
  },

  // TODO: Come up with a better name #peoplefilter
  changePeopleFilterFilter(filterType) {
    Dispatcher.handleViewAction({
      type: ActionTypes.CHANGE_FILTER_PEOPLE_FILTER,
      filterType: filterType
    });
    searchAPI.searchVenues();
  },

  changeLocationFilter(location) {
    Dispatcher.handleViewAction({
      type: ActionTypes.CHANGE_FILTER_LOCATION,
      location: location
    });
    searchAPI.searchVenues();
  },

  changeSorting(sort) {
    Dispatcher.handleViewAction({
      type: ActionTypes.CHANGE_SEARCH_SORTING,
      sort: sort
    });
    searchAPI.searchVenues();
  },

  changeVenueServicesFilter(venueServices) {
    Dispatcher.handleViewAction({
      type: ActionTypes.CHANGE_FILTER_VENUE_SERVICES,
      venueServices: venueServices
    });
    searchAPI.searchVenues();
  },

  changeVenueTitleFilter(title) {
    Dispatcher.handleViewAction({
      type: ActionTypes.CHANGE_FILTER_VENUE_TITLE,
      title: title
    });
    searchAPI.searchVenues();
  },

  changeAvailabilityFilter(availability) {
    Dispatcher.handleViewAction({
      type: ActionTypes.CHANGE_FILTER_AVAILABILITY,
      availability: availability
    });
    searchAPI.searchVenues();
  },

  toggleSearchOnMapDrag(value) {
    invariant(
      typeof value === 'boolean',
      'toggleSearchOnMapDrag expects a boolean value representing the toggled ' +
        'value. Received type: "%s"',
      typeof value
    );
    Dispatcher.handleViewAction({
      type: ActionTypes.TOGGLE_SEARCH_ON_MAP_DRAG,
      value: value
    });
  },

  focusSearchResult(id) {
    Dispatcher.handleViewAction({
      type: ActionTypes.FOCUS_SEARCH_RESULT,
      id: id
    });
  }
};
